export interface nonEvmChainAddressCorrectResponse {
    isActivated: null;
    result: boolean;
    message: null | string;
}
